import Repository from '../Repository';

export default {

	getPeriods() {
		var response = Repository.get('Period/GetPeriods', {});
		return response;
	},

	getSubPeriods() {
		var response = Repository.get('Period/GetSubPeriods', {});
		return response;
	}	

}
